/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventTeam_smartHoldEventInfo = {
    readonly isTeamCalendarSyncEvent: boolean;
    readonly originEvent: {
        readonly title: string | null;
        readonly isAllDay: boolean | null;
        readonly calendarIds: ReadonlyArray<string>;
        readonly eventKey: {
            readonly externalEventId: string;
        };
        readonly organizer: {
            readonly displayName: string | null;
            readonly urnValue: string;
        } | null;
        readonly startTime: {
            readonly millis: number;
            readonly dateOrDateTime: string;
        };
        readonly endTime: {
            readonly millis: number;
            readonly dateOrDateTime: string;
        };
        readonly organizerPerson: ({
            readonly __typename: "Person";
            readonly primaryEmail: string;
            readonly emails: ReadonlyArray<string>;
            readonly profile: {
                readonly givenName: string | null;
                readonly familyName: string | null;
                readonly externalImageUrl: string | null;
            } | null;
            readonly " $fragmentRefs": FragmentRefs<"AvatarPerson_person">;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null;
    };
    readonly " $refType": "EventTeam_smartHoldEventInfo";
};
export type EventTeam_smartHoldEventInfo$data = EventTeam_smartHoldEventInfo;
export type EventTeam_smartHoldEventInfo$key = {
    readonly " $data"?: EventTeam_smartHoldEventInfo$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventTeam_smartHoldEventInfo">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "EventTeam_smartHoldEventInfo",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isTeamCalendarSyncEvent",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "originEvent",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAllDay",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "calendarIds",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventKey",
                        "kind": "LinkedField",
                        "name": "eventKey",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "externalEventId",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Attendee",
                        "kind": "LinkedField",
                        "name": "organizer",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urnValue",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "startTime",
                        "plural": false,
                        "selections": (v0 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "endTime",
                        "plural": false,
                        "selections": (v0 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "organizerPerson",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "primaryEmail",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "emails",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UserProfile",
                                        "kind": "LinkedField",
                                        "name": "profile",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "givenName",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "familyName",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "externalImageUrl",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "AvatarPerson_person"
                                    }
                                ],
                                "type": "Person",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "SmartHoldEventInfo",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '23a2aa1d186f026dd034e8b32f9b318b';
export default node;
